import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

const ImageBox = styled(Box)({
  maxHeight: '300px',
  width: '100%'
})

export default ImageBox
